import { useEffect } from 'react'
import useSWR, { useSWRConfig } from 'swr'
import { libraryAudiencesApi, AudienceLibraryState } from '@/lib/api/library-audiences'
import { useItemCollections } from '@/pages/KnowledgeHubPage/collections/useItemCollections'

export const LIBRARY_AUDIENCES_KEY = '/knowledge/audiences'

/** The existing collection membership remains the owner of manual audience inclusion. */
export function useAudienceLibraryState(audienceToken: string | null) {
  const key = audienceToken ? `${LIBRARY_AUDIENCES_KEY}/${audienceToken}` : null
  const { mutate } = useSWRConfig()
  const collections = useItemCollections(audienceToken ? { kind: 'audience', token: audienceToken } : null)
  const collectionTokens = collections.collections.map(collection => collection.token).sort().join(',')
  const state = useSWR<AudienceLibraryState>(key, () => libraryAudiencesApi.getState(audienceToken!), {
    revalidateOnFocus: false, shouldRetryOnError: false,
  })
  useEffect(() => {
    if (key) {
      void mutate(key)
      void mutate(LIBRARY_AUDIENCES_KEY)
    }
  }, [collectionTokens, key, mutate])
  return state
}
